'use client';

import {
  trackSubmitExperienceOpened,
  trackSubscribeClicked,
} from 'iq-interview_experiences/tracking';
import {PaywallModalContent} from 'iq-upselling/components/paywall_modal_content';
import {useSubscribeHref} from 'iq-upselling/hooks';

interface Props {
  onShare: () => void;
}

export function UnlockInterviewGuideModalContent({onShare}: Props) {
  const subscribeHref = useSubscribeHref();

  return (
    <PaywallModalContent
      title='Unlock full access'
      description='Share your interview experience to unlock all candidate reports and practice questions in this guide. Or subscribe to premium for instant access to all interview guides.'
      primaryAction={
        <button
          onClick={() => {
            void trackSubmitExperienceOpened('modal');
            onShare();
          }}
          className='w-full py-3 bg-iq-red text-white text-sm font-semibold rounded-lg hover:opacity-90 transition-opacity'>
          Share my interview experience
        </button>
      }
      secondaryAction={
        <a
          href={subscribeHref}
          onClick={() => void trackSubscribeClicked('modal')}
          className='px-6 py-2.5 border border-iq-grey-light text-iq-black text-sm font-semibold rounded-md hover:bg-iq-orange-light transition-colors'>
          Subscribe to IQ Premium
        </a>
      }
    />
  );
}
